import React from 'react';
import {
  LightBulbIcon,
  UserGroupIcon,
  HeartIcon,
  EnvelopeIcon,
  DocumentDuplicateIcon,
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ToolCallout from '../../../components/playbooks/ToolCallout';

const CultureOffsiteFinalThoughts = () => {
  return (
    <div className="max-w-none text-gray-300">
      <PlaybookSection
        title="Final Thoughts"
        icon={<LightBulbIcon className="h-7 w-7 text-primary-light" />}
        heading="h1"
      >
        <PlaybookCard>
          <div className="space-y-8">
            <p className="text-gray-300 leading-relaxed">
              'Culture' is one of those problem words these days as invariably it means a bunch of different stuff to different people. Using this playbook creates a united understanding of how you do your best work, that's unique to your business.
            </p>
            
            
          </div>
        </PlaybookCard>
      </PlaybookSection>
    </div>
  );
};

export default CultureOffsiteFinalThoughts; 